import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	padding: 10px;
	align-items: end;

	> h2 {
		font-weight: bold;
	}
`;

export const ShippingCost = styled.p`
	display: flex;
	width: 100%;
	justify-content: space-between;
	font-size: 0.9rem;
	margin: 0 0 8px 0;
	> span:first-child {
		margin-right: 15px;
	}
`;

export const Total = styled.h2`
	display: flex;
	width: 100%;
	justify-content: space-between;
	font-size: 1.5rem;
	> span:first-child {
		margin-right: 20px;
	}
`;
